import { render } from "./_form-content-task.vue?vue&type=template&id=51082e26&lang=pug"
import script from "./_form-content-task.vue?vue&type=script&lang=js"
export * from "./_form-content-task.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__